var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityBubbleImage } from './entity-bubble-image';
import { Image } from '../elements/image';
import { useLang } from '../hooks/use-lang';
var cls = classNames('person-card-image');
export var PersonCardImageDefaultProps = {
  showOrgLogo: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(4))
});
var PhotoStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var OrganisationLogoStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 72px;\n    height: 72px;\n    flex-shrink: 0;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n  "], ["\n    max-width: 72px;\n    height: 72px;\n    flex-shrink: 0;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n  "])))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var MetaStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Photo: styled(EntityBubbleImage)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  OrganisationLogo: styled(Image)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), OrganisationLogoStyles),
  Meta: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles)
};
export var PersonCardImage = function (props) {
  var _a;
  var className = props.className,
    children = props.children,
    entity = props.entity,
    showOrgLogo = props.showOrgLogo,
    meta = props.meta;
  var t = useLang();
  var organisation = entity.organisation,
    badge = entity.badge;
  var hasLogo = showOrgLogo && !!((_a = organisation === null || organisation === void 0 ? void 0 : organisation.logo) === null || _a === void 0 ? void 0 : _a.url);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Photo, {
    size: 96,
    entity: entity
  }), hasLogo && React.createElement(My.OrganisationLogo, {
    image: organisation === null || organisation === void 0 ? void 0 : organisation.logo
  }), meta && React.createElement(My.Meta, null, meta));
};
PersonCardImage.defaultProps = PersonCardImageDefaultProps;
PersonCardImage.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;